/**
 * Get design area dimensions.
 */
export default function designArea(state, side, controller) {
    let useController = state.viewController;
    if (controller) {
        useController = controller;
    }

    if (side === 'front' || side === 'back' || side === 'fronttop' || side === 'backtop') {
        let useSide = side;

        if (useController.blueprint.custom['v-etch-either-side'] === 'true') {
            if (useSide === 'back') {
                useSide = 'front';
            }

            if (useSide === 'backtop') {
                useSide = 'fronttop';
            }
        }

        return {
            left: +useController.blueprint.custom[`v-area-${useSide}-x`],
            top: +useController.blueprint.custom[`v-area-${useSide}-y`],
            right: +useController.blueprint.custom[`v-area-${useSide}-x`] + (+useController.blueprint.custom[`v-area-${useSide}-width`]),
            bottom: +useController.blueprint.custom[`v-area-${useSide}-y`] + (+useController.blueprint.custom[`v-area-${useSide}-height`]),
            width: +useController.blueprint.custom[`v-area-${useSide}-width`],
            height: +useController.blueprint.custom[`v-area-${useSide}-height`],
        };
    }

    return {
    };
}
